import { AbstractService, ApplicationEvent } from '@standardnotes/services';
export class AbstractUIService extends AbstractService {
    constructor(application, internalEventBus) {
        super(internalEventBus);
        this.application = application;
        this.internalEventBus = internalEventBus;
        this.observers = new Set();
        this.addAppEventObserverAfterSubclassesFinishConstructing();
    }
    async onAppStart() {
        return;
    }
    async onAppEvent(_event) {
        return;
    }
    addAppEventObserverAfterSubclassesFinishConstructing() {
        setTimeout(() => {
            this.addAppEventObserver();
        }, 0);
    }
    addAppEventObserver() {
        if (this.application.isStarted()) {
            void this.onAppStart();
        }
        this.unsubApp = this.application.addEventObserver(async (event) => {
            await this.onAppEvent(event);
            if (event === ApplicationEvent.Started) {
                void this.onAppStart();
            }
        });
    }
    addObserver(observer) {
        this.observers.add(observer);
    }
    deinit() {
        ;
        this.application = undefined;
        this.observers.forEach((unsubObserver) => unsubObserver());
        this.unsubApp();
        this.unsubApp = undefined;
        super.deinit();
    }
}
